export default "__VITE_ASSET__B28bzMfu__"